<template>
      <el-drawer class="msDrawer" append-to-body :withHeader="false" :show-close="false" size='450px' :visible.sync="drawerMsg" :destroy-on-close="true" @closed="drawerMsgClose(false)">
                  <div class="msNotice">
                              <div class="msTitle">消息通知</div>
                              <div class="msList" v-if="msList.length>0">
                                    <div class="msItem" v-for="(item,index) in msList" :key="index" @click.stop="updateMessageRead(item)">
                                          <p class="tit tit-01">{{item.companyName}}</p>
                                          <div class="tit clearfix">
                                                <p class="tit-02" :title="item.content">{{item.content}}</p>
                                                <span class="time">{{item.pushTime}}</span>
                                          </div>
                                    </div>
                              </div>
                              <div class="empty" v-else>
                                    <img src="@/assets/subscribe/empty.png">
                                    <p class="center">暂无消息</p>
                              </div>
                  </div>
                  <div class="drawer_footer">
                        <pagination-msg v-if="pageMsg.total" :pageNum="pageMsg.pageNum" :pageSize="pageMsg.pageSize" :total="pageMsg.total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" :key="pageMsg.pageNum" />
                  </div>
      </el-drawer>
</template>
<script>
import {messageList,updateMessageRead} from '@/components/api/messageApi.js'
import PaginationMsg from '@/components/paginationMsg/'
export default {
      components:{
            PaginationMsg
      },
      data(){
            return{
                  loading:false,
                  drawerMsg: false,
                  msList:[],
                  pageMsg:{
                       pageNum: 1,
                        pageSize: 10,
                        total: 0   
                  }
            }
      },
      mounted(){
            
      },
      methods:{
            openDrawerMsg(){
                  this.drawerMsg = true
                  this.pageMsg.pageNum = 1
                  this.getMessageList()
                  this.resetUpdateMessageRead()
            },
            drawerMsgClose(flag){
             this.$parent.getMessageNoRead()
            },
            getMessageList(){
                        let params = {
                              pageSize:this.pageMsg.pageSize,
                              pageNum:this.pageMsg.pageNum 
                        }
                        this.loading = true
                        messageList(params).then(res=>{
                              if(res.code == 200){
                                    this.msList = res.data.records
                                    this.pageMsg.total = res.data.total
                                    this.loading = false
                              }
                        }).catch((error)=>{
                              this.loading = false
                        })
            },
            updateMessageRead(item){
                       this.drawerMsg = false
                        this.getMessageList()
                        if(item.pushType == 3){
                              this.$router.push('/zxk/junbros/subscribeList')
                        }
            },
            resetUpdateMessageRead(){
                        updateMessageRead().then(res =>{
                              if(res.code == 200){
                              }
                        })
            },
            handleSizeChange(val){
                  this.$emit('handle-page-num', val)
            },
            handleCurrentChange (val) {
                  this.$emit('handle-page', val)
                  this.pageMsg.pageNum = val
                  this.getMessageList()
            }
      }
}
</script>
<style lang="scss" scoped>
.clearfix::before,.clearfix::after{
            content: '';
            width: 0;
            height: 0;
            clear: both;
}
.drawer_footer{
      position: absolute;
      bottom: 0;
      width: 100%;
}
</style>
<style lang="scss">
       .msDrawer{
                  .el-drawer__body{
                        padding: 0;
                        box-sizing: border-box;
                  }
                  .msNotice{
                        position: relative;
                        height: 100%;
                        .msTitle{
                              padding: 0 24px;
                              box-sizing: border-box;
                              height: 46px;
                              line-height: 46px;
                              font-weight: bold;
                              color: #333333;
                              font-size: 16px;
                              border-bottom: 1px solid rgb(241,241,242);
                        }
                  }
                  .msList{
                        padding: 8px 24px 0;
                        box-sizing: border-box;
                        .msItem{
                              border-bottom: 1px solid rgba(187,190,202,0.2);
                              font-size: 13px;
                              padding: 16px 0;
                              cursor: pointer;
                              .tit{
                                    height: 18px;
                                    line-height: 18px;
                              }
                              .tit-01{
                                    color: #5088FF;
                                    margin-bottom: 2px;
                                    font-size: 13px;
                                    font-weight: bold;
                              }
                              .tit-02{
                                    color: #666666;
                                    width: 60%;
                                    float: left;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    font-size: 13px;
                                    text-overflow: ellipsis;
                              }
                              .time{
                                    color: #999999;
                                    font-size: 12px;
                                    float: right;
                              }
                        }
                  }
                  .empty{
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 33%;
                        transform: translateY(33%);
                        img{
                              margin: auto;
                              display: block;
                        }
                        .center{
                              text-align: center;
                              color: #999999;
                        }
                  }
            }
</style>
